import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Toolbar, Tabs, Tab, Typography, Box, Grid } from "@mui/material";
import "../styles/TitleStyle.css"; // ✅：一番トップのタイトル表示
import PersonSearchOutlinedIcon from "@mui/icons-material/PersonSearchOutlined";
import ProspectiveCustomerData from "../component/Prospective_customers";
import ProsCustomerKPI from "../component/Prospecting_strategy";
import ProspectManagement from "../component/Prospective_Management";
import SalesReport from "../component/Sales_Activity_Report";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../theme";

const ProsCustomerData = () => {
  const { isAuthenticated } = useAuth0();
  const [value, setValue] = useState(0); // 初期タブを設定

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      {isAuthenticated ? (
        <ThemeProvider theme={theme}>
          <Box
            sx={{
              flexGrow: 1,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              padding: 2,
            }}
          >
            {/* AppBarの高さ分を自動調整 */}
            <Toolbar />

            {/* ✅ ヘッダー */}
            <div>
              <div color="default">
                <Toolbar>
                  <PersonSearchOutlinedIcon sx={{ color: "#C5E763", mr: 1 }} />
                  <Typography variant="h5">新規顧客開拓</Typography>
                </Toolbar>
              </div>
            </div>

            {/* ✅ タブメニュー */}
            <Tabs
              value={value}
              onChange={handleChange}
              sx={{
                borderBottom: 1,
                borderColor: "#C5E763",

                // ✅ すべてのTab（未選択）
                "& .MuiTab-root": {
                  color: "#bdc1c7", // ← クリック前の文字色
                  fontWeight: 500,
                  textTransform: "none",
                },

                // ✅ 選択中のTab
                "& .MuiTab-root.Mui-selected": {
                  color: "#C5E763", // ← クリック後の文字色
                  fontWeight: 700,
                },
              }}
            >
              <Tab label="営業ダッシュボード" />
              <Tab label="見込み顧客情報" />
              <Tab label="未受注案件管理" />
              <Tab label="営業日報" />
            </Tabs>

            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid size={{ xs: 12 }}>
                {value === 0 && <ProsCustomerKPI />}
                {value === 1 && <ProspectiveCustomerData />}
                {value === 2 && <ProspectManagement />}
                {value === 3 && <SalesReport />}
              </Grid>
            </Grid>
          </Box>
        </ThemeProvider>
      ) : (
        <></>
      )}
    </>
  );
};

export default ProsCustomerData;
